var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('edit-role-popup', {
    attrs: {
      "data-to-show": _vm.isPopupRoleDisplayed,
      "is-new-role": _vm.isNewRole
    },
    on: {
      "showChange": function (val) {
        _vm.changeStateEditRolePopup(val);
      }
    }
  }), _vm._v(" "), _c('delete-role-popup', {
    attrs: {
      "data-to-show": _vm.popupDeleteState
    },
    on: {
      "showChange": function (val) {
        _vm.changeStateDeleteRolePopup(val);
      }
    }
  }), _vm._v(" "), _vm.$can(_vm.constants.PERMISSION_GESTION_DROITS_ROLE_AJOUTER) ? _c('add-button', {
    staticClass: "my-10 mx-5 lg:mx-15 2xl:mx-20",
    attrs: {
      "libelle": "Ajouter un rôle"
    },
    on: {
      "add": function ($event) {
        return _vm.displayEditRolePopup();
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('list-grid', {
    attrs: {
      "list-items": _vm.adminRoles.concat(_vm.managerRoles)
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function () {
        return [_c('div', {
          staticClass: "col-span-6 md:col-span-3 ml-5 md:ml-10"
        }, [_vm._v("\n        Rôles\n      ")]), _vm._v(" "), _c('div', {
          staticClass: "col-span-5 hidden lg:inline-block"
        }, [_vm._v("\n        Descriptions\n      ")]), _vm._v(" "), _c('div', {
          staticClass: "col-span-4 md:col-span-2"
        }, [_vm._v("\n        Droits d'accès\n      ")]), _vm._v(" "), _c('div', {
          staticClass: "col-span-2 hidden sm:inline-block text-center mr-5 md:mr-10"
        }, [_vm._v("\n        Suppression\n      ")])];
      },
      proxy: true
    }, {
      key: "accordionDescription",
      fn: function (_ref) {
        var item = _ref.item;
        return [_c('div', {
          staticClass: "col-span-6 md:col-span-3 ml-5 md:ml-10 place-self-center justify-self-start text-lg truncate w-full"
        }, [_vm._v("\n        " + _vm._s(item.name) + "\n      ")]), _vm._v(" "), _c('div', {
          staticClass: "col-span-5 hidden lg:inline-block place-self-center justify-self-start text-base text-gray-600"
        }, [_vm._v("\n        " + _vm._s(item.description) + "\n      ")]), _vm._v(" "), _c('div', {
          staticClass: "col-span-4 md:col-span-2 place-self-center lg:justify-self-start justify-self-center"
        }, [_vm.$can(_vm.constants.PERMISSION_GESTION_DROITS_ROLE_EDITER) && item.type === _vm.constants.ROLE_TYPE_MANAGER ? _c('div', {
          staticClass: "inline-flex items-center justify-center xxl:justify-start w-full group border border-transparent text-sm leading-4 rounded-md focus:outline-none transition ease-in-out duration-150"
        }, [_c('action-button', {
          attrs: {
            "border-color": "border-transparent",
            "text-color": "text-gray-900",
            "bg-color": "bg-indigo-300",
            "bg-color-square": "bg-indigo-200",
            "icon-color": "text-indigo-600",
            "libelle": "Droits d'accès",
            "responsive": true,
            "icon": "edit",
            "text-size": "sm"
          },
          on: {
            "clickAction": function ($event) {
              return _vm.displayEditRolePopup(item);
            }
          }
        })], 1) : _vm._e()]), _vm._v(" "), _c('div', {
          staticClass: "col-span-2 justify-self-center lg:justify-self-start place-self-center mr-5 md:mr-10",
          attrs: {
            "title": "Supprimer le rôle"
          }
        }, [_vm.$can(_vm.constants.PERMISSION_GESTION_DROITS_ROLE_SUPPRIMER) && item.type === _vm.constants.ROLE_TYPE_MANAGER ? _c('circle-button', {
          attrs: {
            "icon": "close",
            "label": "Supprimer le rôle",
            "icon-scale": "75"
          },
          on: {
            "buttonClick": function ($event) {
              return _vm.displayConfirmDeletePopup(item);
            }
          }
        }) : _vm._e()], 1)];
      }
    }])
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }